export default __webpack_public_path__ + "assets/skype.b8d32f4a.svg";